module.exports = __webpack_public_path__ + "static/media/Sketches-2.0a7f760c.jpg";